module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataContainer"
  }, [_c('MainNav'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('InfoMessage')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a212627", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a212627"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 109
// module chunks = 0